<template>
  <el-dialog :title="form.id?'编辑':'新建'" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
      <el-form-item label="标签名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入标签名称" />
      </el-form-item>
      <el-form-item label="描述">
        <el-input v-model="form.remark" />
      </el-form-item>
      <el-form-item label="状态" prop="isEnable">
        <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysGoodsTagApi from '@/api/goods/sysGoodsTag'

import enums from '@/utils/enums'
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    name: null,
    remark: null,
    isEnable: false,
    orderNo: 0
  }
  return formBean
}

export default {
  components: { ImageUpload },
  data() {
    return {
      enums: {
        commStatus: enums.getCommStatus()
      },
      options: {
        sysMenu: []
      },
      form: initFormBean(),
      formVisible: false,
      formRules: {
        name: [{ required: true, message: '请输入商品分类名称', trigger: 'blur' }],
        isEnable: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            sysGoodsTagApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            sysGoodsTagApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
